import React from 'react';
import { connect } from 'react-redux';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import AdminExtensionAPI from '../../../API/Admin/AdminExtensionAPI';
import AdminExtensionTableHeader from './AdminExtensionTableHeader';
import AdminToolbar from '../AdminToolbar';
import AdminExtensionModal from './AdminExtensionModal';
import LinearProgress from '../../Utils/LinearProgress';
import SnackbarAlert from '../../Utils/SnackbarAlert';
import CheckIcon from '@material-ui/icons/Check';
import { STARTING_TABLE_PAGE, DEFAULT_ROWS_PER_PAGE, ORDER_BY_DESCRIPTION, ORDER_ASCENDING, NO_TABLE_DATA_MESSAGE, ADMIN_GROUP } from '../../../Utils/Constants';
import { handleServerError } from '../../../Utils/Helper';


const styles = theme => ({
  paperRoot: {
    width: '100%',
    backgroundColor: '#F6F6F6',
  },
  tableWrapper: {
    overflowX: 'auto',
  },
  tblBorder: {
    border: '2px solid #ffffff',
    fontSize: '12px'
  },
  textCenter: {
    textAlign: 'center',
  },
  tblRow: {
    backgroundColor: '#F2F2F2',
    '&:hover': {
      backgroundColor: theme.palette.primary.light
    },
    '&:nth-of-type(odd)': {
      backgroundColor: '#E1E1E1',
      '&:hover': {
        backgroundColor: theme.palette.primary.light
      },
    },
    height: '30px'
  },
  editWidth: {
    width: '44px'
  },
  activeWidth: {
    width: '88px'
  },
  buttonSizeTbl: {
    width: '30px',
    height: '30px'
  },
  tblFooter: {
    height: '30px',
    minHeight: '30px'
  },
  pageButton: {
    width: '30px',
    height: '30px',
    margin: '0px 8px'
  }
});


class AdminExtensionTable extends React.Component {
  searchTimer = null;
  adminDataAPI;

  constructor(props) {
    super(props);
    this.state = {
      order: ORDER_ASCENDING,
      orderBy: ORDER_BY_DESCRIPTION,
      data: [],
      page: STARTING_TABLE_PAGE,
      rowsPerPage: DEFAULT_ROWS_PER_PAGE,
      count: 0,
      search: '',
      loading: false,
      reloading: false,
      openError: false,
      alertMessage: ''
    };
    this.adminDataAPI = new AdminExtensionAPI();
  }

  componentDidMount() {
    this.reloadTable();
  };

  reloadTable() {
    this.setState({ reloading: true });
    this.adminDataAPI.getAdminTableData(STARTING_TABLE_PAGE, this.state.rowsPerPage, this.state.orderBy, this.state.order, this.state.search).then((response) => {
      this.setState({
        data: response.data.ResultList,
        count: response.data.NumberFilteredResults,
        page: STARTING_TABLE_PAGE,
        reloading: false
      });
    }).catch((error) => {
      this.setState({
        reloading: false,
        openError: true,
        alertMessage: handleServerError(error)
      })
    });
  };

  handleRequestSort = (event, property) => {
    const orderBy = property;
    let order = 'desc';
    if (this.state.orderBy === property && this.state.order === 'desc') {
      order = 'asc';
    }
    this.setState({ reloading: true });
    this.adminDataAPI.getAdminTableData(this.state.page, this.state.rowsPerPage, orderBy, order, this.state.search).then((response) => {
      this.setState({
        data: response.data.ResultList,
        count: response.data.NumberFilteredResults,
        order, orderBy,
        reloading: false
      });
    }).catch((error) => {
      this.setState({
        reloading: false,
        openError: true,
        alertMessage: handleServerError(error)
      })
    });
  };

  handleChangePage = (event, page) => {
    this.setState({ reloading: true });
    this.adminDataAPI.getAdminTableData(page, this.state.rowsPerPage, this.state.orderBy, this.state.order, this.state.search).then((response) => {
      this.setState({
        data: response.data.ResultList,
        count: response.data.NumberFilteredResults,
        page: page,
        reloading: false
      });
    }).catch((error) => {
      this.setState({
        reloading: false,
        openError: true,
        alertMessage: handleServerError(error)
      })
    });
  };

  handleChangeRowsPerPage = event => {
    this.setState({ reloading: true });
    this.adminDataAPI.getAdminTableData(this.state.page, event.target.value, this.state.orderBy, this.state.order, this.state.search).then((response) => {
      this.setState({
        data: response.data.ResultList,
        count: response.data.NumberFilteredResults,
        rowsPerPage: event.target.value,
        reloading: false
      });
    }).catch((error) => {
      this.setState({
        reloading: false,
        openError: true,
        alertMessage: handleServerError(error)
      })
    });
  };

  reloadTableBySearch(searchBy) {
    this.setState({ reloading: true });
    clearTimeout(this.searchTimer);
    this.searchTimer = setTimeout(() => {
      this.adminDataAPI.getAdminTableData(STARTING_TABLE_PAGE, this.state.rowsPerPage, this.state.orderBy, this.state.order, searchBy).then((response) => {
        this.setState({
          data: response.data.ResultList,
          count: response.data.NumberFilteredResults,
          search: searchBy,
          page: STARTING_TABLE_PAGE,
          reloading: false
        });
      }).catch((error) => {
        this.setState({
          reloading: false,
          openError: true,
          alertMessage: handleServerError(error)
        })
      });
    }, 1500);
  };

  handleCloseSnackbar = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    this.setState({
      openError: false,
      alertMessage: ''
    });
  };

  handleCloseDialog = () => {
    this.setState({
      openDialog: false,
      reloading: false,
      loading: false,
      success: false
    });
  };

  handleClickDelete = (componentId) => {
    this.setState({
      openDialog: true,
      confirmationQuestion: 'Tem a certeza que pretende ELIMINAR o registo?',
      confirmationMessage: 'O registo será eliminado, não sendo possível aos utilizadores da aplicação visualizá-lo, no entanto, permanecerá na BD com a informação de registo eliminado.',
      confirmationFunction: () => this.handleSubmitDelete(componentId),
      cancelFunction: this.handleCloseDialog
    });
  };

  handleSubmitDelete = (componentId) => {
    this.setState({ loading: true })
    this.adminDataAPI.deleteElement(componentId).then(() => {
      this.setState({
        loading: false,
        success: true
      });
      setTimeout(() => {
        this.setState({
          success: false
        });
        this.handleCloseDialog()
        this.reloadTable()
      }, 500)
    }).catch((error) => {
      this.setState({
        loading: false,
        openError: true,
        alertMessage: handleServerError(error)
      })
    });
  };

  renderTableRecords(componentDataList) {
    const { classes } = this.props;

    const componentData = componentDataList.map(componentItem => {
      return (
        <TableRow key={componentItem.Id} tabIndex={-1} className={classes.tblRow}>
          <TableCell className={classNames(classes.tblBorder, classes.textCenter)} component='th' scope='row' padding='none'>
            {componentItem.Id}
          </TableCell>
          <TableCell className={classNames(classes.tblBorder, classes.textCenter)} component='th' scope='row' padding='none'>
            {componentItem.Description}
          </TableCell>
          <TableCell className={classNames(classes.tblBorder, classes.textCenter, classes.activeWidth)} component='th' scope='row' padding='none'>
            {!componentItem.Deleted ? <CheckIcon /> : null}
          </TableCell>
          {this.props.user.UserRoleType.indexOf(ADMIN_GROUP) < 0 ?
            null :
            <TableCell className={classNames(classes.tblBorder, classes.textCenter, classes.editWidth)} padding='none'>
              <AdminExtensionModal newEditButton={false} element={componentItem} reloadTable={this.reloadTable.bind(this)} />
            </TableCell>
          }
        </TableRow>
      );
    })
    return componentData;
  }

  renderNoRecordMessages() {
    return NO_TABLE_DATA_MESSAGE;
  }


  render() {
    const { classes } = this.props;
    const { data, order, orderBy, rowsPerPage, page, count, reloading } = this.state;

    return (
      <Paper className={classes.paperRoot}>

        <AdminToolbar
          reloadTableBySearch={this.reloadTableBySearch.bind(this)}
          reloadTable={this.reloadTable.bind(this)}
          titleTableList={this.props.titleTableList}
        />
        <div className={classes.tableWrapper}>
          <Table>
            <AdminExtensionTableHeader
              order={order}
              orderBy={orderBy}
              onRequestSort={this.handleRequestSort}
              reloadTable={this.reloadTable.bind(this)}
            />
            <TableBody>
              {this.renderTableRecords(data)}
            </TableBody>
          </Table>
          {(!data.length) ? this.renderNoRecordMessages() : null}
        </div>
        {reloading && <LinearProgress />}
        <TablePagination
          component='div'
          count={count}
          rowsPerPage={rowsPerPage}
          rowsPerPageOptions={[5, 10, 25, 50]}
          labelRowsPerPage={'Resultados por página:'}
          page={page}
          backIconButtonProps={{ className: classes.pageButton }}
          nextIconButtonProps={{ className: classes.pageButton }}
          onChangePage={this.handleChangePage}
          onChangeRowsPerPage={this.handleChangeRowsPerPage}
          labelDisplayedRows={({ from, to, count }) => `A mostrar resultados ${from}-${to} de ${count}`}
          classes={{ toolbar: classes.tblFooter }}
        />

        <SnackbarAlert openError={this.state.openError} alertMessage={this.state.alertMessage} handleCloseSnackbar={this.handleCloseSnackbar} />

      </Paper>
    );
  }
}

AdminExtensionTable.propTypes = {
  classes: PropTypes.object.isRequired,
  reloadTable: PropTypes.func,
  reloadTableBySearch: PropTypes.func
};

const mapStateToProps = state => ({
  ...state,
});

export default connect(mapStateToProps)(withStyles(styles)(AdminExtensionTable));


// WEBPACK FOOTER //
// ./src/components/Administration/AdminExtension/AdminExtensionTable.js